/* eslint-disable no-shadow, no-param-reassign */
import { uniqueId, merge } from 'lodash-es';
import {
    STATE_AVAILABLE,
    STATE_SELECTED,
    STATE_ASSIGNED,
    STATE_ASSIGNED_SELECTED,
    STATE_UNASSIGNED,
    STATE_UNASSIGNED_SELECTED,
    STATE_UNAVAILABLE,
    STATE_NOT_DEFINED,
} from '@/components/venue_items/states';
import * as actions from './actions';
import * as getters from './getters';
import {
    INSPECT_SEAT,
    ADD_TICKET,
    REMOVE_TICKET,
    ADD_TO_BASKET_PENDING,
    ADD_TO_BASKET_FAILED,
    SELECT_ITEM_FOR_EDITING,
    BATCH_SELECT,
    DESELECT_ITEM_FOR_EDITING,
    TOGGLE_ITEM_SELECTION_FOR_EDITING,
    CLEAR_SELECTION,
    ASSIGN_ITEMS_PENDING,
    ASSIGN_ITEMS_COMPLETE,
    ASSIGN_ITEMS_FAILED,
    SELECT_ALL,
    FILL_TICKET_STORE,
    TOGGLE_TICKET_STORE,
    MERGE_STATE,
    SET_BOOKING_LAYER_VISIBILITY,
    SET_ADDITIONAL_PARAMS,
    ADD_TO_BASKET_SUCCESS,
    SET_ITEMS,
    SET_MARKETING_TITLE,
    SET_PRODUCTS,
    SET_EVENT_NAME,
    SET_EVENT_CODE,
    SET_MAP,
} from './mutation-types';

const state = {
    additionalParams: {},
    assignments: {},
    venueId: '',
    config: {},
    selectedTickets: [],
    selectedItemsForEditing: [],
    errorMessage: '',
    loading: false,
    redirectTo: '',
    items: {},
    bookingLayerVisible: false,
    eventCode: '',
    products: {},
    marketingTitle: '',
    eventName: '',
    map: '',
};

const mutations = {
    [INSPECT_SEAT](state, payload) {
        state.inspectedSeat = {
            vsid: payload.vsid,
            x: payload.x,
            y: payload.y,
            ...state.seats[payload.vsid],
        };
    },
    [ADD_TICKET](state, vsid) {
        const instanceId = uniqueId();

        // state.selectedTickets.push({ vsid, instanceId });
        state.selectedTickets.unshift({ vsid, instanceId });
        state.items[vsid].state = STATE_SELECTED;
    },
    [REMOVE_TICKET](state, query) {
        let filtered;

        if (
            typeof query === 'string'
        ) {
            filtered = state.selectedTickets.filter(elem => elem.vsid !== query);
        } else if (typeof query === 'object') {
            // TODO: ez nem jol mukodik
            ['vsid', 'instanceId'].forEach((paramName) => {
                if (typeof query[paramName] !== 'undefined') {
                    filtered = state.selectedTickets.filter(
                        elem => elem[paramName] !== query[paramName],
                    );
                }
            });
        }

        state.selectedTickets = filtered;

        if (query.type && query.type === 'seat') {
            state.items[query.vsid].state = STATE_AVAILABLE;
        } else {
            const found = state.selectedTickets.find(elem => elem.vsid === query.vsid);

            state.items[query.vsid].state = found ? STATE_SELECTED : STATE_AVAILABLE;
        }
    },
    [FILL_TICKET_STORE](state) {
        const selectedTickets = [];
        const keys = Object.keys(state.items);

        keys.forEach((vsid) => {
            if (state.items[vsid].state === STATE_SELECTED) {
                const quantity = state.items[vsid].selectedQuantity || 1;

                for (let i = 0; i < quantity; i += 1) {
                    const instanceId = uniqueId();

                    selectedTickets.push({
                        vsid,
                        instanceId,
                    });
                }
            }
        });

        state.selectedTickets = selectedTickets;
    },
    [TOGGLE_TICKET_STORE](state) {
        state.isTicketStoreMobileActive = !state.isTicketStoreMobileActive;
    },
    [ADD_TO_BASKET_PENDING](state) {
        state.errorMessage = '';
        state.loading = true;
    },
    [ADD_TO_BASKET_FAILED](state, payload) {
        state.loading = false;
        state.errorMessage = payload;
    },
    [ADD_TO_BASKET_SUCCESS](state) {
        state.loading = false;
    },
    [SELECT_ITEM_FOR_EDITING](state, payload) {
        state.selectedItemsForEditing.push(payload.vsid);

        switch (state.items[payload.vsid].state) {
            case STATE_ASSIGNED:
                state.items[payload.vsid].state = STATE_ASSIGNED_SELECTED;
                break;
            case STATE_UNASSIGNED:
                state.items[payload.vsid].state = STATE_UNASSIGNED_SELECTED;
                break;
            default:
        }
    },
    [BATCH_SELECT](state, payload) {
        payload.forEach((e) => {
            if (
                state.items[e] &&
                state.items[e].state !== STATE_UNAVAILABLE &&
                state.items[e].state !== STATE_NOT_DEFINED
            ) {
                state.items[e].selected = true;
            }
        });
    },
    [DESELECT_ITEM_FOR_EDITING](state, payload) {
        state.selectedItemsForEditing = state.selectedItemsForEditing.filter(
            e => e.vsid !== payload.vsid,
        );

        switch (state.items[payload.vsid].state) {
            case STATE_ASSIGNED_SELECTED:
                state.items[payload.vsid].state = STATE_ASSIGNED;
                break;
            case STATE_UNASSIGNED_SELECTED:
                state.items[payload.vsid].state = STATE_UNASSIGNED;
                break;
            default:
        }
    },
    [TOGGLE_ITEM_SELECTION_FOR_EDITING](state, vsid) {
        if (typeof state.items[vsid].selected !== 'undefined') {
            state.items[vsid].selected = !state.items[vsid].selected;
        } else {
            state.items[vsid].selected = true;
        }
    },
    [CLEAR_SELECTION](state) {
        const keys = Object.keys(state.items);

        keys.forEach((e) => {
            state.items[e].selected = false;
        });
    },
    [SELECT_ALL](state) {
        const keys = Object.keys(state.items);

        keys.forEach((e) => {
            state.items[e].state = STATE_UNASSIGNED_SELECTED;
        });
    },
    [ASSIGN_ITEMS_PENDING](state, payload) {
        state.loading = true;

        const assignments = {};
        const keys = Object.keys(state.items);

        keys.forEach((vsid) => {
            if (!state.items[vsid].selected) {
                return;
            }

            const item = {};

            // korabbi osszerendeles ha van
            if (state.items[vsid].assignmentId && state.items[vsid].assignmentId !== '') {
                item.assignmentId = state.items[vsid].assignmentId;
            }

            item.product = payload.productId;
            item.venuePlaceId = state.items[vsid].venuePlaceId;
            item.type = state.items[vsid].type;

            assignments[vsid] = item;
        });

        state.assignments = assignments;
    },
    [ASSIGN_ITEMS_COMPLETE](state, payload) {
        state.loading = false;

        const keys = Object.keys(payload);

        keys.forEach((vsid) => {
            const assigned = payload[vsid].assignmentId && payload[vsid].assignmentId !== '';

            state.items[vsid].assignmentId = payload[vsid].assignmentId || '';
            state.items[vsid].errorMessage = payload[vsid].errorMessage || '';
            state.items[vsid].name = payload[vsid].name || '';
            state.items[vsid].product = assigned ? payload[vsid].product : '';
            state.items[vsid].state = assigned
                ? STATE_ASSIGNED
                : STATE_UNASSIGNED;
            state.items[vsid].success = typeof payload[vsid].success !== 'undefined' ?
                payload[vsid].success : true;
            state.items[vsid].type = payload[vsid].type || '';
            state.items[vsid].venuePlaceId = payload[vsid].venuePlaceId || '';
        });
    },
    [ASSIGN_ITEMS_FAILED](state, payload) {
        state.loading = false;
        state.errorMessage = payload;
    },
    [MERGE_STATE](state, payload) {
        state = merge(state, payload);
    },
    [SET_BOOKING_LAYER_VISIBILITY](state, payload) {
        state.bookingLayerVisible = payload;
    },
    [SET_ADDITIONAL_PARAMS](state, payload) {
        state.additionalParams = payload;
    },
    [SET_MARKETING_TITLE](state, payload) {
        state.marketingTitle = payload;
    },
    [SET_PRODUCTS](state, payload) {
        state.products = payload;
    },
    [SET_EVENT_NAME](state, payload) {
        state.eventName = payload;
    },
    [SET_EVENT_CODE](state, payload) {
        state.eventCode = payload;
    },
    [SET_MAP](state, payload) {
        state.map = payload;
    },
    [SET_ITEMS](state, payload) {
        state.items = payload;
    },
};

export default {
    state,
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/booking/index.js